import React from 'react'

const STATUS_CONFIG = {
  collecting: { label: 'Abierto',    color: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-700/50' },
  locked:     { label: 'Bloqueado',  color: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700/50' },
  running:    { label: 'En curso',   color: 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-700/50' },
  completed:  { label: 'Completado', color: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700' },
  cancelled:  { label: 'Cancelado',  color: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700/50' },
}

export default function CohortStatusBadge({ status, className = '' }) {
  const cfg = STATUS_CONFIG[status] || { label: status || '?', color: 'bg-gray-100 text-gray-600 border-gray-200' }
  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 text-[10px] rounded border font-medium ${cfg.color} ${className}`}>
      {cfg.label}
    </span>
  )
}
